import styled from 'styled-components';
import MuiCard from "@material-ui/core/Card";

export const StyledMuiCard = styled(MuiCard)`
  && {
    box-shadow: 0px 2px 12px rgba(38, 66, 124, 0.1);
    color: #17181A;
    border-radius: 8px;

    &.MuiPaper-outlined {
      box-shadow: none;
      border: 1px solid #E1E9FA;
    }
  }
`;
